module.exports = __webpack_public_path__ + "static/media/si-porcelain.739ab822.png";